<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.jornada"
        ref="RkmDataTable"
        sort-by="numeroPlaca"
        search-by="numeroPlaca"
    >

        <template v-slot:cell(numeroPlaca)="row">
            {{ row.value | formatPlaca }}
        </template>

        <template v-slot:cell(actions)="{ item }">
            <template v-if="!$scopedSlots.actions">
                <rkm-button
                    @click="handleEdit(item.id)"
                    color="primary"
                    small
                    title="Editar"
                    autorize="edit-transporte-paciente-jornada"
                >
                    <rkm-icon icon="pen"/>
                </rkm-button>

                <slot
                    name="actions"
                    :jornada="item"
                />
            </template>
        </template>
    </rkm-data-table>
</template>

<script>

// Mixins.
import { error, repository, stringCase} from '@/mixins';

// Filters.
import formats from '@/filters/formats'

export default {
    computed: {
        fields() {
            return [
                {
                    key: 'numeroPlaca',
                    label: 'Placa',
                    name: 'veiculo.numeroPlaca',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'descricaoModelo',
                    label: 'Modelo',
                    name: 'veiculo.descricaoModelo',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'descricaoMarca',
                    label: 'Marca',
                    name: 'marca.descricao',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'descricaoTipo',
                    label: 'Tipo',
                    name: 'tipo.descricao',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'anoFabricacao',
                    label: 'Ano',
                    name: 'veiculo.anoFabricacao',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'descricaoCor',
                    label: 'Cor predominante',
                    name: 'cor.descricao',
                    searchable: true,
                    sortable: true,
                },
                {
                    class: 'col-min text-center',
                    key: 'actions',
                    label: 'Ações',
                }
            ];
        }
    },
    created() {
        this.repositories = {
            jornada: this.getConectaSusRepository('transportePaciente.jornada')
        }
    },
    filters: {
        formatPlaca: formats.numeroPlaca,
    },
    methods: {
        handleEdit(id) {
            this.$router.push({ name: 'transporte-paciente-jornada-edit', params: { id: id } })
        },
    },
    mixins: [ error, repository, stringCase ],
};

</script>